import React from 'react';
import Icon from '../../../components/AppIcon';

const DashboardHeader = ({ user, activeTab }) => {
  const getGreeting = () => {
    const hour = new Date()?.getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 18) return 'Good Afternoon';
    return 'Good Evening';
  };

  const tabTitles = {
    trips: 'My Trips',
    favorites: 'Favorites',
    bookings: 'Bookings',
    recommendations: 'For You',
    settings: 'Settings'
  };

  return (
    <div className="bg-gradient-to-r from-primary/10 via-secondary/10 to-accent/10 border-b border-border">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-10">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-2">
              {getGreeting()}, {user?.name || 'Traveler'}!
            </h1>
            <p className="text-sm md:text-base text-muted-foreground">
              {activeTab === 'trips' && 'Manage your saved itineraries and upcoming adventures'}
              {activeTab === 'favorites' && 'Your collection of dream destinations'}
              {activeTab === 'bookings' && 'Track your reservations and confirmations'}
              {activeTab === 'recommendations' && 'Personalized suggestions just for you'}
              {activeTab === 'settings' && 'Customize your travel preferences'}
            </p>
          </div>
          <div className="flex items-center gap-3">
            <div className="bg-card rounded-xl px-4 py-3 shadow-sm">
              <div className="flex items-center gap-2">
                <Icon name="MapPin" size={20} color="var(--color-primary)" />
                <div>
                  <p className="text-xs text-muted-foreground">Next Trip</p>
                  <p className="text-sm font-semibold text-foreground">Boracay</p>
                </div>
              </div>
            </div>
            <div className="bg-card rounded-xl px-4 py-3 shadow-sm">
              <div className="flex items-center gap-2">
                <Icon name="Calendar" size={20} color="var(--color-secondary)" />
                <div>
                  <p className="text-xs text-muted-foreground">Days Until</p>
                  <p className="text-sm font-semibold text-foreground">12</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;